import { DateTimeISO, PaginatedResponse, Status } from './common';
import { BaseCompany } from './companies';

export type StaffMemberListItem = {
  uuid: string;
  fullName: string;
  avatar: string | null;
  email: string;
  status: Status;
  totalActiveCompanies: number;
};

export type StaffListResponse = {
  staffs: PaginatedResponse<StaffMemberListItem>;
};

export type StaffMemberDetails = {
  uuid: string;
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  phoneNumber: string;
  businessPhoneNumber: string;
  bio: string;
  avatar: string | null;
  status: Status;
  isSandboxUser: boolean;
  companies: {
    uuid: string;
    name: string;
  }[];
  totalActiveCompanies: number;
  createdAt: DateTimeISO;
  lastLoginAt: DateTimeISO;
  deactivatedAt: DateTimeISO;
};

export type StaffForSelectItem = {
  uuid: string;
  firstName: string;
  lastName: string;
  fullName: string;
};

export type StaffFormValues = {
  uuid: string;
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  phoneNumber: string;
  businessPhoneNumber: string;
  bio: string;
  avatarUrl: string;
  avatarDisplayName: string;
  isSandboxUser: boolean;
  sandboxPassword: string;
};

export interface StaffFormEditValues extends StaffFormValues {
  uuid: string;
}

export type PublicStaff = {
  uuid: string;
  companies: BaseCompany[];
};

export const queryKeys = {
  list: ['staffList'] as const,
  selectionList: ['staffSelectionList'] as const,
  details: ['staffDetails'] as const,
  preflight: ['staffPreflight'] as const,
};
